import { render, staticRenderFns } from "./PostCareerNavbar.vue?vue&type=template&id=045db9d4&scoped=true&"
import script from "./PostCareerNavbar.vue?vue&type=script&lang=js&"
export * from "./PostCareerNavbar.vue?vue&type=script&lang=js&"
import style0 from "./PostCareerNavbar.vue?vue&type=style&index=0&id=045db9d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045db9d4",
  null
  
)

export default component.exports